class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resultsContainer = this.querySelector('[data-predictive-search]');
    this.loadingText = this.dataset.loadingText || 'Loading...';

    this.debounceTimer = null;
    this.addEventListeners();
  }

  addEventListeners() {
    this.input.addEventListener('input', () => {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.onInput(), 300);
    });
  }

  onInput() {
    const query = this.input.value.trim();

    if (query.length < 3) {
      this.resultsContainer.innerHTML = '';
      return;
    }

    this.resultsContainer.innerHTML = `<div class="loading">${this.loadingText}</div>`;

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
      .then(res => res.json())
      .then(data => {
        const products = data.resources.results.products;
        if (!products.length) {
          this.resultsContainer.innerHTML = '<div>No results found</div>';
          return;
        }

        this.resultsContainer.innerHTML = products.map(p => `
          <div class="predictive-search__item">
            <a href="${p.url}">
              ${p.featured_image ? `<img src="${p.featured_image.url}" width="40" height="40" style="margin-right:8px;">` : ''}
              ${p.title}
            </a>
          </div>
        `).join('');
      })
      .catch(() => {
        this.resultsContainer.innerHTML = '<div>Error loading results</div>';
      });
  }
}

customElements.define('predictive-search', PredictiveSearch);
